import _implicitStylesheets from "./relatedSkills.css";
import _implicitScopedStylesheets from "./relatedSkills.scoped.css?scoped=true";
import _wdsListingCard from "wds/listingCard";
import _listingRecommendationCarousel from "listing/recommendationCarousel";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "recommendation-card": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, c: api_custom_element, h: api_element, i: api_iterator} = $api;
  return [$cmp.hasCards ? api_custom_element("listing-recommendation-carousel", _listingRecommendationCarousel, {
    props: {
      "title": $cmp.heading,
      "itemCount": $cmp.cardCount,
      "previousLabel": $cmp.previousLabel,
      "nextLabel": $cmp.nextLabel
    },
    key: 0
  }, api_iterator($cmp.cards, function (card, index) {
    return api_element("li", {
      slotAssignment: "cards",
      classMap: stc0,
      key: api_key(1, card.oafId)
    }, [api_custom_element("wds-listing-card", _wdsListingCard, {
      props: {
        "positionIndex": index,
        "listingCardData": card,
        "visibleCategoryLimit": $cmp.visibleCategoryLimit,
        "variant": "with-badge"
      },
      key: 2
    })]);
  })) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4qbjuhbidbf";
tmpl.legacyStylesheetToken = "undefined-_relatedSkills";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
